import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { neturalBlack, netural400, primaryOrange } from "../../../constants/color";

const TransferFilterBar = ({
  filters,
  onFilterChange,
  onClearFilters,
  totalCount,
}) => {
  const handleInputChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  return (
    <div
      style={{
        border: "1px solid #DADADA",
        borderRadius: "12px",
        padding: "16px",
        backgroundColor: "#ffffff",
        marginBottom: "20px",
      }}
    >
      {/* Filter Label */}
      <div
        style={{
          fontSize: "14px",
          fontWeight: "600",
          color: neturalBlack,
          marginBottom: "8px",
        }}
      >
        Filter
      </div>

      {/* First Row: Dropdowns and Search */}
      <Row style={{ marginBottom: "16px", alignItems: "center" }}>
        <Col lg={2} md={4} sm={6} xs={12} style={{ marginBottom: "8px" }}>
          <Form.Select
            value={filters.status || ""}
            onChange={(e) => handleInputChange("status", e.target.value || undefined)}
            style={{
              borderRadius: "12px",
              border: "1px solid #DADADA",
              fontSize: "14px",
            }}
          >
            <option value="">All Statuses</option>
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
            <option value="on_hold">On Hold</option>
            <option value="processing">Processing</option>
            <option value="scheduled">Scheduled</option>
            <option value="reversed">Reversed</option>
            <option value="cancelled">Cancelled</option>
          </Form.Select>
        </Col>

        <Col lg={2} md={4} sm={6} xs={12} style={{ marginBottom: "8px" }}>
          <Form.Select
            value={filters.orderType || ""}
            onChange={(e) => handleInputChange("orderType", e.target.value || undefined)}
            style={{
              borderRadius: "12px",
              border: "1px solid #DADADA",
              fontSize: "14px",
            }}
          >
            <option value="">All Types</option>
            <option value="Product">Product</option>
            <option value="Service">Service</option>
            <option value="Offer">Offer</option>
            <option value="autoship">Autoship</option>
            <option value="Tip">Tip</option>
          </Form.Select>
        </Col>

        <Col lg={3} md={4} sm={6} xs={12} style={{ marginBottom: "8px" }}>
          <Form.Control
            type="text"
            placeholder="Search by ID or Business Name..."
            value={filters.search || ""}
            onChange={(e) => handleInputChange("search", e.target.value || undefined)}
            style={{
              borderRadius: "12px",
              border: "1px solid #DADADA",
              fontSize: "14px",
            }}
          />
        </Col>

        <Col lg={2} md={4} sm={6} xs={12} style={{ marginBottom: "8px" }}>
          <Form.Control
            type={filters.startDate ? "date" : "text"}
            placeholder="Start Date"
            value={filters.startDate ? filters.startDate.split('T')[0] : ""}
            onChange={(e) => {
              const value = e.target.value;
              handleInputChange("startDate", value ? `${value}T00:00:00.000Z` : undefined);
            }}
            onFocus={(e) => {
              e.target.type = "date";
            }}
            onBlur={(e) => {
              if (!e.target.value) e.target.type = "text";
            }}
            style={{
              borderRadius: "12px",
              border: "1px solid #DADADA",
              fontSize: "14px",
            }}
          />
        </Col>

        <Col lg={2} md={4} sm={6} xs={12} style={{ marginBottom: "8px" }}>
          <Form.Control
            type={filters.endDate ? "date" : "text"}
            placeholder="End Date"
            value={filters.endDate ? filters.endDate.split('T')[0] : ""}
            onChange={(e) => {
              const value = e.target.value;
              handleInputChange("endDate", value ? `${value}T23:59:59.999Z` : undefined);
            }}
            onFocus={(e) => {
              e.target.type = "date";
            }}
            onBlur={(e) => {
              if (!e.target.value) e.target.type = "text";
            }}
            style={{
              borderRadius: "12px",
              border: "1px solid #DADADA",
              fontSize: "14px",
            }}
          />
        </Col>

        <Col
          lg={1}
          md={4}
          sm={6}
          xs={12}
          style={{ marginBottom: "8px", textAlign: "right" }}
        >
          <button
            onClick={onClearFilters}
            style={{
              padding: "0",
              border: "none",
              backgroundColor: "transparent",
              color: primaryOrange,
              fontSize: "14px",
              cursor: "pointer",
              fontWeight: "500",
              textDecoration: "underline",
            }}
          >
            Clear
          </button>
        </Col>
      </Row>

      {/* Sort Label */}
      <div
        style={{
          fontSize: "14px",
          fontWeight: "600",
          color: neturalBlack,
          marginBottom: "8px",
        }}
      >
        Sort
      </div>

      {/* Second Row: Sort and Count */}
      <Row style={{ alignItems: "center" }}>
        <Col lg={2} md={4} sm={6} xs={12} style={{ marginBottom: "8px" }}>
          <Form.Select
            value={filters.sortBy || "createdAt"}
            onChange={(e) => handleInputChange("sortBy", e.target.value)}
            style={{
              borderRadius: "12px",
              border: "1px solid #DADADA",
              fontSize: "14px",
            }}
          >
            <option value="createdAt">Created Date</option>
            <option value="grossAmount">Gross Amount</option>
            <option value="sellerAmount">Net Paid</option>
            <option value="releaseDate">Release Date</option>
            <option value="status">Status</option>
          </Form.Select>
        </Col>

        <Col lg={2} md={4} sm={6} xs={12} style={{ marginBottom: "8px" }}>
          <Form.Select
            value={filters.sortOrder || "desc"}
            onChange={(e) => handleInputChange("sortOrder", e.target.value)}
            style={{
              borderRadius: "12px",
              border: "1px solid #DADADA",
              fontSize: "14px",
            }}
          >
            <option value="desc">Newest First</option>
            <option value="asc">Oldest First</option>
          </Form.Select>
        </Col>

        <Col
          lg={8}
          md={4}
          sm={12}
          xs={12}
          style={{
            marginBottom: "8px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <label
            style={{
              fontSize: "14px",
              color: netural400,
              margin: 0,
            }}
          >
            {totalCount || 0} transfers
          </label>
        </Col>
      </Row>
    </div>
  );
};

export default TransferFilterBar;
